import { useState, useEffect } from 'react'
import { getIncomeOTFlatrateTypeAPI } from '../services/in-come'

function UseIncomeOTFlatrateType() {
  const [data, setData] = useState([])
  useEffect(() => {
    const getData = async () => {
      const resp = await getIncomeOTFlatrateTypeAPI()
      if (!resp) return
      if (resp.status) {
        setData(
          resp.result.map((d) => ({ label: d.otFlatRate, value: d.otFlatRateId }))
        )
      }
    }
    getData()
  }, [])

  return data
}

export default UseIncomeOTFlatrateType
